<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form :inline="false" label-position="top" size="small">
        <el-row
          :gutter="20" justify="flex-start" style="flex-wrap: wrap"
          type="flex"
        >
          <el-col :span="5">
            <!--  运单号   -->
            <el-form-item prop="selectType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.selectType" :style="IsWidth1">
                    <el-option key="1" :label="$t('newOrder.waybillNumber')" :value="1" />
                    <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="queryForm.params.inputValue"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="1"
                style="width: 100%"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--时间-->
            <el-form-item :label="$t('GlobalSetObj.SigningTime')" prop="timeType">
              <el-date-picker
                v-model="timeValue"
                :clearable="true"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale == 'zh' ? zhDate : ptDate"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="queryForm.params.regionId"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 州 -->
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.stateSite1')">
              <el-select
                v-model="queryForm.params.stateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--   实际派送网点   -->
            <el-form-item :label="$t('GlobalSetObj.entrega')">
              <el-select
                v-model="queryForm.params.siteList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in preDeliverySiteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--   与收件人距离   -->
            <el-form-item class="distance-wrapper">
              <el-select v-model="signDistanceCompare" class="distanceClass" style="width: 100%">
                <el-option :label="$t('collectionCenter.greaterThanAddresseeDistance')" value=">" />
                <el-option :label="$t('collectionCenter.lessThanAddresseeDistance')" value="<=" />
              </el-select>
              <el-select
                v-model="queryForm.params.signDistance"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :value="10" label="10" />
                <el-option :value="50" label="50" />
                <el-option :value="100" label="100" />
                <el-option :value="200" label="200" />
                <el-option :value="500" label="500" />
                <el-option :value="1000" label="1000" />
                <el-option :value="2000" label="2000" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--   POD上传方式   -->
            <el-form-item :label="$t('navbar.podUploadMethod')">
              <el-select
                v-model="queryForm.params.podUploadType"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :label="$t('navbar.scanBarcode')" :value="1" />
                <el-option :label="$t('navbar.enterTrackingNumber')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <!--   客户   -->
          <el-col :span="4">
            <el-form-item :label="$t('placeOrder.client')">
              <el-select
                v-model="queryForm.params.customerIdList"
                :placeholder="$t('collectionCenter.tudo')"
                :remote-method="getCustomerPage"
                clearable filterable
                multiple collapse-tags
                remote reserve-keyword
                style="width: 100%"
                @change="changeCustomer"
                @clear="getCustomerPage('')"
                @focus="getCustomerPage('', true)"
              >
                <el-option
                  v-for="item in customerIdData"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--   商户   -->
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.CommercialOwner')">
              <ElSelectV2
                v-model="merchantList"
                :options="merchantData"
                :placeholder="$t('collectionCenter.tudo')"
                clearable filterable multiple
                collapse-tags
                remote
                :remote-method="remoteMethod"
                style="width: 100%"
                popper-class="SelectV2_popper"
                @visible-change="getMerchant"
                @change="changeMerchant"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8" style="display: flex; justify-content: flex-start; align-items: center">
            <div>
              <!--搜索-->
              <el-button size="small" type="primary" @click="enterSearch">{{ $t('newOrder.search') }}
              </el-button>
              <el-button size="small" @click="allExportOrder">{{ $t('newOrder.export') }}
              </el-button>
              <!--重置-->
              <el-button size="small" type="info" @click="resetForm">{{ $t('newOrder.reset') }}
              </el-button>

              <!--批量导出单号-->
              <el-button size="small" @click="orderNumberExport">{{ $t('placeOrder.BatchExport') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <!--  表格数据  -->
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
      >
        <el-table-column
          :label="`${$t('GlobalSetObj.serial', 'zh')}（${$t('GlobalSetObj.serial', 'pu')}）`"
          align="center"
          type="index"
          width="80"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.center"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row[item.prop] || scope.row[item.prop] == 0 ? `${scope.row[item.prop]}` : '--'
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--  批量单号导出 -->
    <exportOrderNumber ref="exportOrderNumberRef" />
  </div>
</template>

<script>
import {
  getLgAreaListData,
  regionQueryList,
  selectInfoByStateTwo,
  signLocationexportSign,
  signLocationPage
} from '@/api/orderApi';
import dayjs from 'dayjs';
import { Loading } from 'element-ui';
import { goRWExportList } from '@/utils/goExportList.js';
import ElSelectV2 from 'el-select-v2';
import { apiCustomerPage } from '@/api/customer';
import { queryAllMerchantCode } from '@/api/lanshou';

export default {
  name: 'SignLatLonMonitoring',
  components: {
    exportOrderNumber: () => import('./component/exportOrderNumber.vue'),
    ElSelectV2
  },
  data() {
    return {
      merchantList: [],
      prevMerchantList: [],
      customerIdData: [],
      merchantData: [],
      allSiteListCache: null, // 全部网点数据缓存
      sitesByRegionAndState: {},
      regionList: [],
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          timeType: 1,
          selectType: 1,
          siteList: [],
          stateList: [],
          inputValue: '',
          signDistanceCompare: '>',
          signDistance: '',
          regionId: null,
          podUploadType: '',
          customerIdList: [],
          merchantCodeList: []
        }
      },
      signDistanceCompare: '>',
      tableData: [],
      preDeliverySiteList: [],
      tableHeaderList: [
        // 签收时间
        {
          id: 1,
          label: `${this.$t('GlobalSetObj.SigningTime', 'zh')}（${this.$t(
            'GlobalSetObj.SigningTime',
            'pu'
          )}）`,
          prop: 'signTime',
          cloWidth: '170',
          center: 'center'
        },
        // 运单号
        {
          id: 2,
          label: `${this.$t('newOrder.waybillNumber', 'zh')}（${this.$t(
            'newOrder.waybillNumber',
            'pu'
          )}）`,
          prop: 'waybillNumber',
          cloWidth: '160',
          center: 'center'
        },
        // 扫描单号
        {
          id: 3,
          label: `${this.$t('GlobalSetObj.ScanNumber', 'zh')}（${this.$t(
            'GlobalSetObj.ScanNumber',
            'pu'
          )}）`,
          prop: 'scanOrderNumber',
          cloWidth: '160',
          center: 'center'
        },
        // 客户
        {
          id: 4,
          label: `${this.$t('GlobalSetObj.client', 'zh')}（${this.$t(
            'GlobalSetObj.client',
            'pu'
          )}）`,
          prop: 'customerName',
          cloWidth: '150',
          center: 'center'
        },
        // 大区
        { id: 13, label: '大区（Região）', prop: 'regionName', cloWidth: '100', center: 'center' },
        // 州
        {
          id: 5,
          label: `${this.$t('GlobalSetObj.Estado', 'zh')}（${this.$t(
            'GlobalSetObj.Estado',
            'pu'
          )}）`,
          prop: 'stateName',
          cloWidth: '140',
          center: 'center'
        },
        // 实际派送网点
        {
          id: 6,
          label: `${this.$t('GlobalSetObj.entrega', 'zh')}（${this.$t(
            'GlobalSetObj.entrega',
            'pu'
          )}）`,
          prop: 'siteName',
          cloWidth: '150',
          center: 'center'
        },
        // 派送员
        {
          id: 7,
          label: `${this.$t('orderCenterCont.deliveryPerson', 'zh')}（${this.$t(
            'orderCenterCont.deliveryPerson',
            'pu'
          )}）`,
          prop: 'delivererName',
          cloWidth: '150',
          center: 'center'
        },
        // 实际签收经纬度
        {
          id: 8,
          label: `${this.$t('navbar.actuallySignLoc', 'zh')}（${this.$t(
            'navbar.actuallySignLoc',
            'pu'
          )}）`,
          prop: 'actuallySignLoc',
          cloWidth: '170',
          center: 'center'
        },
        // 收件人签收经纬度
        {
          id: 9,
          label: `${this.$t('navbar.receiveSignLoc', 'zh')}（${this.$t(
            'navbar.receiveSignLoc',
            'pu'
          )}）`,
          prop: 'receiveSignLoc',
          cloWidth: '170',
          center: 'center'
        },
        // 与收件地址直线距离(米)
        {
          id: 10,
          label: `${this.$t('navbar.signDistance', 'zh')}（${this.$t(
            'navbar.signDistance',
            'pu'
          )}）`,
          prop: 'signDistance',
          cloWidth: '180',
          center: 'center'
        },
        // 网点经纬度
        {
          id: 11,
          label: `${this.$t('navbar.siteSignLoc', 'zh')}（${this.$t('navbar.siteSignLoc', 'pu')}）`,
          prop: 'siteSignLoc',
          cloWidth: '170',
          center: 'center'
        },
        // 与网点直线距离(米)
        {
          id: 12,
          label: `${this.$t('navbar.siteDistance', 'zh')}（${this.$t(
            'navbar.siteDistance',
            'pu'
          )}）`,
          prop: 'siteDistance',
          cloWidth: '170',
          center: 'center'
        },
        // POD上传方式
        {
          id: 120,
          label: `${this.$t('navbar.podUploadMethod', 'zh')}（${this.$t(
            'navbar.podUploadMethod',
            'pu'
          )}）`,
          prop: 'podUploadTypeName',
          cloWidth: '170',
          center: 'center'
        }
      ],
      StateList: [] // 用户列表
    };
  },
  computed: {
    IsWidth1() {
      return {
        width: this.isTormat ? '180px' : '100px'
      };
    }
  },
  watch: {
    regionList: {
      deep: true,
      handler(newVal) {
        if (newVal.length > 0) {
          this.groupSitesByRegionAndState();
        }
      }
    },
    'queryForm.params.regionId'(newVal) {
      // 当 regionId 发生变化时，重新设置 StateList
      this.queryForm.params.stateList = [];
      this.queryForm.params.siteList = null;
      if (newVal && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.StateList = selectedRegion.states.map((state) => ({
            label: state
          }));
        }
        this.preDeliverySiteList = selectedRegion?.sites || [];
        this.groupSitesByRegionAndState();
      } else {
        this.StateList = [];
        this.preDeliverySiteList = [];
        this.getAddress();
        this.remoteGetSiteList('');
      }
    },
    'queryForm.params.stateList'(newVal) {
      const regionId = this.queryForm.params.regionId;

      if (regionId) {
        this.queryForm.params.siteList = null;
      }
      if (!regionId && newVal) {
        if (this.allSiteListCache) {
          this.preDeliverySiteList = this.allSiteListCache;
        } else {
          this.remoteGetSiteList(); // 如果缓存不存在再请求
        }
        return;
      }

      // 如果没有选择州，则显示当前大区下的所有网点
      if (regionId && (!newVal || newVal.length <= 0)) {
        const selectedRegion = this.regionList.find((r) => r.id === regionId);
        this.preDeliverySiteList = selectedRegion?.sites || [];
      }
      if (regionId && newVal && newVal.length > 0) {
        // 多选州：合并所有选中州下的网点
        const mergedSites = [];
        newVal.forEach((state) => {
          const sitesInState = this.sitesByRegionAndState[regionId]?.[state] || [];
          mergedSites.push(...sitesInState);
        });
        this.preDeliverySiteList = mergedSites;
      }
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
    this.remoteGetSiteList('');
    this.getAddress();
    this.getRegion();
  },
  methods: {
    changeCustomer() {
      this.merchantList = [];
      this.prevMerchantList = [];
      this.queryForm.params.merchantCodeList = [];
    },
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerIdData.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerIdData = res.data.records;
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerIdData = res.data.records;
          }
        });
      }
    },
    changeMerchant(value) {
      const newList = value || [];
      this.prevMerchantList = [...newList];
      this.queryForm.params.merchantCodeList = newList.length > 0
        ? [...new Set(newList.map(id => {
          const found = this.merchantData.find(m => m.value === id);
          return found ? found.merchantCode : '';
        }))]
        : [];
    },
    getMerchant(val) {
      if (val) {
        this.remoteMethod('');
      }
    },
    remoteMethod(value) {
      const merchantForm = {
        customerId: '',
        merchantCode: '',
        customerIdList: this.queryForm.params.customerIdList,
        merchantName: value
      };
      queryAllMerchantCode(merchantForm).then(res => {
        if (res.code === 200) {
          const newData = (res.data.records || []).map((item) => ({
            value: item.id,
            label: item.merchantName + ' / ' + item.merchantCode,
            merchantCode: item.merchantCode
          }));
          // 将已选中的项追加到末尾（跳过新数据中已存在的）
          const existingIds = new Set(newData.map(m => m.value));
          const selectedItems = this.merchantData.filter(m =>
            this.merchantList.includes(m.value) && !existingIds.has(m.value)
          );
          this.merchantData = [...newData, ...selectedItems];
        }
      });
    },
    orderNumberExport() {
      this.$refs.exportOrderNumberRef.handleOpen();
    },
    // 大区
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    groupSitesByRegionAndState() {
      const grouped = {};
      this.regionList.forEach((region) => {
        if (!grouped[region.id]) {
          grouped[region.id] = {};
        }

        region.sites.forEach((site) => {
          const key = site.state; // 区分大小写
          if (!grouped[region.id][key]) {
            grouped[region.id][key] = [];
          }
          grouped[region.id][key].push(site);
        });
      });

      this.sitesByRegionAndState = grouped;
    },
    // 查询
    getSearch() {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        this.timeValue = [];
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      const data = {
        params: {}
      };
      this.queryForm.params.signDistanceCompare = this.signDistanceCompare;
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params = this.queryForm.params;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.beginTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        data.params.beginTime = null;
        data.params.endTime = null;
      }
      if (this.queryForm.params.selectType === 1) {
        data.params.waybillNumberList = inputValList;
        data.params.scanOrderNumberList = [];
      } else {
        data.params.scanOrderNumberList = inputValList;
        data.params.waybillNumberList = [];
      }
      signLocationPage(data).then((res) => {
        if (res.status === 'OK') {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    allExportOrder() {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      const data = this.queryForm.params;
      if (this.timeValue && this.timeValue.length > 0) {
        data.beginTime = this.timeValue[0];
        data.endTime = this.timeValue[1];
      } else {
        data.beginTime = null;
        data.endTime = null;
      }
      if (this.queryForm.params.selectType === 1) {
        data.waybillNumberList = inputValList;
        data.scanOrderNumberList = [];
      } else {
        data.scanOrderNumberList = inputValList;
        data.waybillNumberList = [];
      }
      signLocationexportSign(data).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    // 获取最近一周时间
    getTimer() {
      // 获取当前时间
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(1, 'months').format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        timeType: 1,
        selectType: 1,
        siteList: [],
        stateList: [],
        inputValue: '',
        signDistanceCompare: '>',
        signDistance: '',
        regionId: null,
        podUploadType: '',
        customerIdList: [],
        merchantCodeList: []
      };
      this.merchantList = [];
      this.prevMerchantList = [];
      this.signDistanceCompare = '>';
      this.getSearch();
      this.getCustomerPage('');
      this.remoteMethod('');
    },
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.status === 'OK') {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 获取所有网点
    remoteGetSiteList() {
      if (this.allSiteListCache) {
        this.preDeliverySiteList = this.allSiteListCache;
        return Promise.resolve();
      }
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const value = {};
      selectInfoByStateTwo(value)
        .then((res) => {
          if (res.code === 200) {
            this.allSiteListCache = res.data.siteList; // 缓存全部网点
            this.preDeliverySiteList = [...this.allSiteListCache]; // 初始化为全量数据
            load.close();
          }
        })
        .finally(() => {
          load.close();
        });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    }
  }
};
</script>

<style>
.SelectV2_popper { width: 260px !important; }
</style>
<style lang="scss" scoped>
.distance-wrapper ::v-deep .el-form-item__content {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.distance-wrapper ::v-deep .el-select {
  margin-bottom: 0;
}
.distanceClass ::v-deep .el-input {
  line-height: 29px !important;
}
.distanceClass ::v-deep .el-input__inner {
  border: none;
  height: 28px !important;
  line-height: 28px !important;
  text-align: left;
  color: #4e5969;
  font-weight: 500;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  text-align: left;
  color: #4e5969;
  font-weight: 500;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}
</style>
